<template>
{{displayPrice()}}
</template>

<script>
import { computed, inject } from 'vue'
import { formatCurrencyNoRound, exchangeRate, formatCurrencyRound } from '~/helper'
import { useCurrenciesStore } from '~/store/pinia/currencies'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

export default {
  name: 'CalculatorDisplayPrice',
  props: ['originalPrice'],
  setup(props) {
    const currenciesStore = useCurrenciesStore()
    const tripPlanStore = useTripPlanStore()

    const currencySelected = computed(() => currenciesStore.currencySelected /*store.state.currenciesStore.currencySelected*/)
    const dataTrip = computed(() => tripPlanStore.dataTrip)
    const typeTripPlan = inject('typeTripPlan', '')
    const currencyOriginalData = computed(() => tripPlanStore.originalRate)

    const displayPrice = () => {
      const { rate, code } = currencySelected.value

      if(dataTrip.value.is_booked) {
        if(dataTrip.value.booked_currency !== dataTrip.value.original_currency) {
          if(typeTripPlan.value === 'gallery_trip_plan') return exchangeRate(props.originalPrice,currencyOriginalData.value.rate, dataTrip.value.booked_exchange_rate, false, true, true)
          return exchangeRate(props.originalPrice,currencyOriginalData.value.rate, dataTrip.value.booked_exchange_rate, true, false, true)
        }
        else {
          if(typeTripPlan.value === 'gallery_trip_plan') return formatCurrencyRound(props.originalPrice)
          return formatCurrencyNoRound(parseFloat(props.originalPrice))
        }
      }
      else {
        if (code !== dataTrip.value.original_currency) {
          if(typeTripPlan.value === 'gallery_trip_plan') return exchangeRate(props.originalPrice,currencyOriginalData.value.rate, rate, false, true, true)
          return exchangeRate(props.originalPrice,currencyOriginalData.value.rate, rate, true, false, true)
        } else {
          if(typeTripPlan.value === 'gallery_trip_plan') return formatCurrencyRound(props.originalPrice)
          return formatCurrencyNoRound(parseFloat(props.originalPrice))
        }
      }
    }

    return {displayPrice}
  }
}
</script>

<style scoped>

</style>
